<template>
			<div>
				<b-container fluid>
					<b-row class="mt-3 mb-2">
						<b-col lg="6" sm="12" class="text-left">
							<h5>Pickup Address</h5>
						</b-col>
						<b-col lg="6" sm="12" class=" text-right">
							<b-button v-if="showAddaddress==0" variant="dark" pill class="mr-2" @click="showAddaddress=1"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add New Address</b-button>
							
							<!--<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>-->
						</b-col>
					</b-row>
				</b-container>
				<b-container fluid v-if="showAddaddress==1" class="mb-3">
				
					<b-row>
					<b-col>
						<b-form-group :state="shippingaddressState.firstname" label="First name" label-for="sa-firstname" invalid-feedback="First name is required!" label-size="sm">
							<b-form-input id="sa-firstname" v-model="shippingaddress.firstname" :state="shippingaddressState.firstname" @focusin="shippingaddressState.firstname = null" size="sm"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group :state="shippingaddressState.lastname" label="Last name" label-for="sa-lastname" invalid-feedback="Last name is required!" label-size="sm">
							<b-form-input id="sa-lastname" v-model="shippingaddress.lastname" :state="shippingaddressState.lastname" @focusin="shippingaddressState.lastname = null" size="sm"></b-form-input>
						</b-form-group>
					</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group :state="shippingaddressState.email" label="Email" label-for="sa-email" invalid-feedback="Email should be valid!" label-size="sm">
								<b-form-input id="sa-email" v-model="shippingaddress.email" :state="shippingaddressState.email" @focusin="shippingaddressState.email = null" size="sm"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group :state="shippingaddressState.phone" label="Phone" label-for="sa-phone"  :invalid-feedback="shippingaddressError.phone" label-size="sm">
								<b-form-input id="sa-phone" v-model="shippingaddress.phone" :state="shippingaddressState.phone" @focusin="shippingaddressState.phone = null" size="sm" maxlength="10" ></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group :state="shippingaddressState.address" label="Street address" label-for="sa-address" invalid-feedback="Street address is required!" label-size="sm">
								<b-form-input id="sa-address" v-model="shippingaddress.address" :state="shippingaddressState.address" @focusin="shippingaddressState.address = null" size="sm"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group :state="shippingaddressState.city" label="City" label-for="sa-city" invalid-feedback="City is required!" label-size="sm">
								<b-form-input id="sa-city" v-model="shippingaddress.city" :state="shippingaddressState.city" @focusin="shippingaddressState.city = null" size="sm"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group :state="shippingaddressState.state" label="State" label-for="sa-state" invalid-feedback="State is required!" label-size="sm">
								<b-form-input id="sa-state" v-model="shippingaddress.state" :state="shippingaddressState.state" @focusin="shippingaddressState.state = null" size="sm"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group :state="shippingaddressState.pincode" label="Pincode" label-for="sa-pincode" invalid-feedback="Pincode is required!" label-size="sm">
								<b-form-input id="sa-pincode" v-model="shippingaddress.pincode" :state="shippingaddressState.pincode" size="sm"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col> 
							<b-form-group label="Country" label-for="sa-country" label-size="sm">
								<b-form-select id="sa-country" v-model="shippingaddress.country" size="sm">
									<b-form-select-option value="IN" selected>India</b-form-select-option>
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							
						</b-col>
						<b-col>
							<b-button type="reset" variant="light" @click="showAddaddress=0" pill>Cancel</b-button>
							<b-link class="btn-solid btn2 float-right" @click="addShipping()" >Save Address</b-link>
						</b-col>
					</b-row>
										

				</b-container>
				<b-container fluid>
					<b-row>
						<b-col class="col-md-12 col-sm-12 col-xs-12">
							<div class="container-box">
								<b-row class="mt-4 px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Show</span>
										<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
										</b-form-select>
										
									</b-col>
									<b-col lg="4" offset-md="2">
										<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
											<b-input-group size="sm">
												<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
												</b-form-input>
												<b-input-group-append>
													<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row class="px-3 pt-3">
									<b-col lg="12">
										<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
											<!-- <template v-slot:cell(status)="row">
												<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
												<b-badge pill variant="success" v-else-if="row.value == 1">ACTIVE</b-badge>
												<b-badge pill variant="danger" v-else>REJECTED</b-badge>
											</template>
											<template v-slot:cell(thumbnail)="row">
												<b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img>
												<b-img v-bind="thumbnailProps" rounded alt="" v-else :src="row.value.replace('_rg','_th')">{{row}}</b-img>
											</template> -->
											<template v-slot:cell(actions)="row">
												<!-- <b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button> -->
												<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteShippigaddress(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
											</template>
										</b-table>
									</b-col>
								</b-row>
								<b-row class="px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
									</b-col>
									<b-col lg="3" offset-md="3">
										<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
					</b-container>
			</div>
				
				
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'ProfileBank',
  components: {
  //"cart-variant": CartVariant,
  },
  props: {
   /* cartItems: { type: Array },
    cartData: { type: Object  },
	cartTotalqty:Number,*/
  },
  mounted(){
  //this.inLodcard;
  this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		addshippingurl: this.$root.WEBURL+'addpickupaddress',
		getshippingurl: this.$root.WEBURL+'getpickupaddress',
		deleteshippingUrl: this.$root.WEBURL+'deletepickupaddress',
		totalRows: 1,
		currentPage: 1,
		pageOptions: [10, 20, 50, 100],
		perPage: 10,
		sortBy: '',
		sortDesc: false,
		sortDirection: 'asc',
		filter: null,
		filterOn: [],
		records: [], 
		fields: [
			/*{ key: 'id', label: 'ID'},*/
			{ key: 'firstname', label: 'Firstname'},
			{ key: 'lastname', label: 'Lastname'},
			{ key: 'email', label: 'Email'},
			{ key: 'phone', label: 'Phone'},
			{ key: 'address', label: 'Address'},
			{ key: 'city', label: 'City' },
			{ key: 'state', label: 'state' },
			{ key: 'pincode', label: 'pincode' },
			{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
		],
		showAddaddress:0,
		shippingaddress: {
			firstname:'',
			lastname:'',
			email:'',
			phone:'',
			address:'',
			city:'',
			state:'',
			pincode:'',
			srpickup:'',
		},
		shippingaddressState: {
			firstname: null,
			lastname: null,
			email: null,
			phone: null,
			address: null,
			city: null,
			state: null,
			pincode: null
		},
		shippingaddressError: {
			phone: 'Phone number is required!',
			
		},
		srToken:'',
		randomNumber:'',
				
		
		
    }
  },
  methods:{
		inLodcard(){
			 var self = this;
			/* User Shipping Address List*/
			self.axios.post(self.getshippingurl, {
				accesskey: self.$root.customer_info.access_key
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				   self.records = response.data.result.shippingaddressData;
				   self.totalRows = self.records.length;
				   // self.$root.customer_info.billing = response.data.result.billing;
					//console.log(response.data.result.info);
					
					//self.related_products = response.data.result.related_products;
					//console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			/* ---------- SR Token generate -------- */
			if(self.srToken==''){
				var shipRocketUrl='https://apiv2.shiprocket.in/v1/external/auth/login';
				self.axios.post(shipRocketUrl, {
					email: "mahato@alluraa.com",
					password: "Mahato@123"
				})
				.then(function (response) {
					//console.log(response);
					var objResp = response.data;
					self.srToken = objResp.token;
					
					//console.log('MyToken'+self.srToken);

					

				})
				.catch(function (error) {
					alert(error);
				});
			}
			
			
			
		}, 
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1;
		},
		addShipping(){
			//alert('len'+this.shippingaddress.firstname.length);
			this.randomNumber = Math.floor(Math.random(1234451)*10000);
			var valid = true;
			if(this.shippingaddress.firstname.length < 3) {
				this.shippingaddressState.firstname = false;
				valid = false;
			}else this.shippingaddressState.firstname = true;

			if(this.shippingaddress.lastname.length < 3) {
				this.shippingaddressState.lastname = false;
				valid = false;
			}else this.shippingaddressState.lastname = true;
			
			if(!this.validateemail(this.shippingaddress.email)){
			  valid = false;
			  this.shippingaddressState.email = false;
			}else{
			  this.shippingaddressState.email = true;
			}
			/*if(this.shippingaddress.email.length < 10) {
				this.shippingaddressState.email = false;
				valid = false;
			}else this.shippingaddressState.email = true;*/

			/* if(this.shippingaddress.phone.length < 10) {
				this.shippingaddressState.phone = false;
				valid = false;
			}else this.shippingaddressState.phone = true; */
			
			if(this.shippingaddress.phone.length <10){
				this.shippingaddressError.phone='Please enter Phone number!';
				valid = false;
				this.shippingaddressState.phone = false;
			}else if(!/^[0-9]+$/.test(this.shippingaddress.phone)){
				this.shippingaddressError.phone='Phone number should be only digits!';
				valid = false;
				this.shippingaddressState.phone = false;			
			}else{
				this.shippingaddressState.phone= true;
			}
			

			if(this.shippingaddress.address.length < 4) {
				this.shippingaddressState.address = false;
				valid = false;
			}else this.shippingaddressState.address = true;
			
			if(this.shippingaddress.city.length < 3) {
				this.shippingaddressState.city = false;
				valid = false;
			}else this.shippingaddressState.city = true;
			
			if(this.shippingaddress.state.length < 3) {
				this.shippingaddressState.state = false;
				valid = false;
			}else this.shippingaddressState.state = true;
			
			if(this.shippingaddress.pincode.length < 6) {
				this.shippingaddressState.pincode = false;
				valid = false;
			}else this.shippingaddressState.pincode = true;
			/* ====================== ShftRocket Pickup Process =========== */
			console.log('MyToken'+this.srToken);
			 //var randomNumber = Math.floor(Math.random()*50);
			//var srpickupAddress ='Home'+randomNumber;
			var srpickupAddress ='Add'+this.randomNumber;
			this.shippingaddress.srpickup =srpickupAddress;
			

			if(valid){
				var self = this;
				
				
				
				
				
				self.axios.post(self.addshippingurl, {
					accesskey: self.$root.customer_info.access_key,
					billing: self.shippingaddress						
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						//console.log("ddd"+response.data);
						self.shippingaddressData = response.data.result.shippingaddressData;
						self.showAddaddress=0;
						
						
						/* =============== ADD PICKUP ADDRESS IN SR ============== */ 
						var addressList = { pickup_location: srpickupAddress,
								name: self.shippingaddress.firstname+' '+self.shippingaddress.lastname,
								email: self.shippingaddress.email,
								phone: self.shippingaddress.phone,
								address: self.shippingaddress.address,
								address_2: "",
								city: self.shippingaddress.city,
								state:self.shippingaddress.state,
								country: "India",
								pin_code: self.shippingaddress.pincode			
							}
			
						//console.log('addressList'+addressList);
			
							self.axios({
								url: "https://apiv2.shiprocket.in/v1/external/settings/company/addpickup",
								method: 'post',
								headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
								data:addressList
								})
							  .then(res => {
								console.log(`Axios Call completed: ${res}`);
								
							  });
						
						/* ======================================= */
						
						
						self.shippingaddress={
							firstname:'',
							lastname:'',
							email:'',
							phone:'',
							address:'',
							city:'',
							state:'',
							pincode:''
						};
						self.shippingaddressState={
							firstname: null,
							lastname: null,
							email: null,
							phone: null,
							address: null,
							city: null,
							state: null,
							pincode: null
						};
						
						self.inLodcard();
						//self.$root.resetCart();
						//self.$router.push('/order-success');
						//console.log(self.share_data);
						//alert(response.data.message);
					}else if(response.data.error == 9){
						self.$root.forceLogout(response.data.message);
					}else{
						alert(response.data.message);
					}
				})
				.catch(function (error) {
					alert(error);
				});
			}
			

		},
		validateemail(email){
			var atposition=email.indexOf("@");  
			var dotposition=email.lastIndexOf(".");  
			if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
			return false;  
			}else{
			return true;
			}
		},
		showDeleteShippigaddress(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Address Inforamtion!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteshippingUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.inLodcard();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},



    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">


</style>
